import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Margin, ContentLoader } from 'shared/components'
import * as styles from './styles'

const AccountTokenCheckComponent = ({ onCheckTokenHash, token, nonce }) => {
  useEffect(() => {
    onCheckTokenHash(token, nonce)
  }, [])

  return (
    <Margin css={styles.loader}>
      <ContentLoader loading={true} />
    </Margin>
  )
}

AccountTokenCheckComponent.propTypes = {
  onCheckTokenHash: PropTypes.func.isRequireds,
  token: PropTypes.string.isRequireds,
  nonce: PropTypes.any,
}

export default observer(AccountTokenCheckComponent)
